<template>
  <div class="grey lighten-5" style="margin-top:30px;">
    <!-- 辛さランキング -->
    <v-card flat style="max-width: 800px;margin:0 auto;">
      <v-container>
      <v-flex xs12>
        <h2 style="margin-bottom:10px;text-align:left;font-size:20pt;"><span class="primary--text">辛さ</span>ランキング</h2>
      </v-flex>
      <p style="font-weight:bold;text-align:left">みんなの辛さ比較からランキングを作りました！</p>
      <v-btn class="rankBtn" color="primary" large block :to="{name: 'searchFood', query: {sort: 'hot', s: '1'}}">
        <img src="/img/rankIcon/chilifire.png">全体の辛さランキング
      </v-btn>
      <v-layout row wrap>
        <v-flex xs6 style="padding-right:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'nudle',sort: 'hot', s: '1'}}">
            <img src="/img/rankIcon/nudle.png">ラーメン
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-left:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'curry',sort: 'hot', s: '1'}}">
            <img src="/img/rankIcon/curry.png"><span style="margin-right:16px;">カレー</span>
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-right:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'yakisoba',sort: 'hot', s: '1'}}">
            <img src="/img/rankIcon/yakisoba.png">やきそば
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-left:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'rice',sort: 'hot', s: '1'}}">
            <img src="/img/rankIcon/gohan.png">ごはん系
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-right:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'snack',sort: 'hot', s: '1'}}">
            <img src="/img/rankIcon/okashi.png"><span style="margin-right:16px;">お菓子</span>
          </v-btn>
        </v-flex>
        <v-flex xs6 style="padding-left:5px">
          <v-btn class="rankBtn" outline color="primary" block :to="{name: 'searchFood', query: {category: 'tsumami',sort: 'hot', s: '1'}}">
            <img src="/img/rankIcon/otsumami.png">おつまみ
          </v-btn>
        </v-flex>
      </v-layout>
      </v-container>
    </v-card>
    <!-- ／辛さランキング -->

    <!-- 辛いニュース-->
    <v-card flat style="max-width:800px;margin:0 auto;padding-top:10px">
      <h2 style="margin-bottom:10px;text-align:left;font-size:20pt;padding-left:16px">
        <span class="primary--text">辛い</span>ニュース
      </h2>
      <news-card :p=p v-for="p in news" :key=p.id></news-card>
      <p style="text-align:center;">
        <v-btn color="primary"
          :to="{name: 'NewsList'}"
        >
          辛いニュースをもっと見る</v-btn>
      </p>
    </v-card>
    <!-- /辛いニュース-->

    <v-card flat style="max-width:800px;margin:0 auto;" class="grey lighten-5">
      <v-container>
      <v-card flat style="text-align:center">
        <p style="margin-bottom:0;">
          <router-link :to="{name: 'about'}">
            <img
              class="white--text imageSP"
              v-lazy="require('@/assets/img/top.png')"
            />
          </router-link>
        </p>
        <v-container>
          <router-link :to="{name: 'about'}" style="color:#333;text-decoration:none;">激辛グルメの口コミサイト「<span style="color:#f44336;text-decoration:underline;font-weight:bold">カライイネ</span>」とは？</router-link>
        </v-container>
      </v-card>
      <v-flex xs12 style="margin-bottom:30px;">
        <v-layout row wrap>
          <v-flex xs12 md4 style="padding:0 5px;"><v-btn :to="{name: 'searchFood'}" block outline color="primary"><v-icon>search</v-icon>&nbsp;カライモノを探す</v-btn></v-flex>
          <v-flex xs12 md4 style="padding:0 5px;"><v-btn :to="{name: 'searchShops'}" block outline color="primary"><v-icon>restaurant</v-icon>&nbsp;カライ飲食店を探す</v-btn></v-flex>
          <v-flex xs12 md4 style="padding:0 5px;"><v-btn :to="{name: 'searchReview'}" block outline color="primary"><v-icon>chat_bubble_outline</v-icon>&nbsp;みんなのカラログ</v-btn></v-flex>
          <v-flex xs12 md4 style="padding:0 5px;"><v-btn :to="{name: 'reviewPostSearchFood'}" block outline color="primary"><v-icon>edit</v-icon>&nbsp;カラログを投稿</v-btn></v-flex>
          <v-flex xs12 md4 style="padding:0 5px;"><v-btn :to="{name: 'about'}" block outline color="primary">カライイネとは？</v-btn></v-flex>
          <!-- <v-flex xs12 md4 style="padding:0 5px;"><v-btn :to="{name: 'MagazinList'}" block outline color="primary"><v-icon>local_library</v-icon>マガジン</v-btn></v-flex> -->
          <v-flex xs12 md4 style="padding:0 5px;"><a href="https://forms.gle/zXZp7ayR9KAq5MGs5" targert="_blank" style="text-decoration:none;"><v-btn block outline color="primary">お問い合わせ</v-btn></a></v-flex>
          <v-flex xs12 md4 style="padding:0 5px;"><v-btn :to="{name: 'editFood'}" block outline color="primary"><v-icon>add</v-icon>&nbsp;食品登録</v-btn></v-flex>
        </v-layout>
      </v-flex>
        <v-flex xs12>
          <h3 class="primary--text">カテゴリからカライモノを探す</h3>
          <div>
            <v-btn flat :to="{name: 'searchFood', query: {category: 'nudle', s: '1'}}">ラーメン</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {category: 'yakisoba', s: '1'}}">やきそば</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {category: 'curry', s: '1'}}">カレー</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {category: 'pasta', s: '1'}}">パスタ</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {category: 'snack', s: '1'}}">お菓子</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {category: 'tsumami', s: '1'}}">おつまみ</v-btn>
          </div>
          <h3 class="primary--text">特徴からカライモノを探す</h3>
          <div>
            <v-btn flat :to="{name: 'searchFood', query: {tag: '痺れ', s: '1'}}">しびれ</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {tag: 'カップ麺', s: '1'}}">カップ麺</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {tag: 'セブンイレブン', s: '1'}}">セブンイレブン</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {tag: 'ローソン', s: '1'}}">ローソン</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {tag: 'ファミリーマート', s: '1'}}">ファミマ</v-btn>
            <v-btn flat :to="{name: 'searchFood', query: {tag: 'インスタント麺', s: '1'}}">インスタント麺</v-btn>
          </div>
        </v-flex>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import NewsCard from '@/news/NewsCard.vue'
export default {
  name: 'MidFooter',
  data () {
    return {
      newsMax: 6,
      news: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      let news = await this.$store.dispatch('getNews')
      for (let i = 0; i< this.newsMax; i++) {
        this.news.push(news[i])
      }
    }
  },
  components: {
    NewsCard
  }
}
</script>
<style scoped>
  .imageSP {
    width: 80%;
  }
  .imageMD {
    height: 300px;
  }
  .rankBtn {
    font-weight:bold;
    font-size:13pt;
    border-radius:6px;
    height:55px;
  }
  .rankBtn img {
    height:40px;
    margin-right:10px;
  }
</style>
